import { render, staticRenderFns } from "./deliveryReceiveConfirmation.vue?vue&type=template&id=e20e26f6&scoped=true&"
import script from "./deliveryReceiveConfirmation.vue?vue&type=script&lang=js&"
export * from "./deliveryReceiveConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./deliveryReceiveConfirmation.vue?vue&type=style&index=0&id=e20e26f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20e26f6",
  null
  
)

component.options.__file = "deliveryReceiveConfirmation.vue"
export default component.exports